export function formatForUrl(str) {
    return encodeURIComponent(str.trim());
}

/**
 * Format angka untuk tampilan: pemisah ribuan gaya Indonesia dan maksimal dua
 * angka di belakang koma. Bilangan bulat tidak dipaksa memiliki desimal.
 *
 * Dipakai bersama oleh tabel dan modal detail agar formatnya tidak bercabang.
 */
export function formatNumber(value) {
    if (value === null || value === undefined || value === "" || isNaN(value)) return "0";

    return new Intl.NumberFormat("id-ID", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(value);
}
